import { IOneMessageJson } from "../../../../../../nodeserver/structs/database.js";
import JSX from "../../../helpers/react.js";
import RefObject = JSX.RefObject;
import { appearClass, hasSpecialActions } from "../../../messages/helpers.js";
import { ServerApi } from "../../../api.js";
import { MessageHistory } from "../history.js";
import { hideAllActions } from "../user-actions.js";

export function HistoryActionElement(props: {
    msg: IOneMessageJson,
    message: RefObject<HTMLDivElement>,
    withText: boolean,
    //чтобы переключать на:
    //1) отображать когда сообщение удалено
    //2) отображать когда сообщение не удалено 
    showOn: "deleted" | "viewed" 
}){

    let isShow:boolean;
    
    if(props.showOn === "deleted")
        isShow = props.msg.deleted;
    else
        isShow = !props.msg.deleted;


    const historyElement = isShow &&  hasSpecialActions(props.msg.from_id) ? (
        <div className="action-element"
             onClick={() => messageHistoryClickEvent(props.message.value!, props.msg.nickname, props.msg.from_id)}
        >
            <div className="message-action-padding">
                <img src="/img/message-history.svg" className="action-element-img"/>
            </div>
            {!!props.withText && <div className="message-action-padding" style={{color: 'var(--light-text)'}}>История изменений</div>}
        </div>
    ) : <></>;
    return historyElement;
    
}



export function addElementToMessageWrapper(element: HTMLElement) {
    $($(".messages-container-wrapper")[0]).prepend(element);
    setTimeout(() => {
        $(".message-history-container").addClass(appearClass);
    }, 100)
}


export async function messageHistoryClickEvent(message: HTMLDivElement, nickname: string, from_id: number) {
    let history = await ServerApi.messages.messageHistory(+message.dataset.id!);
    let element: HTMLElement = <MessageHistory
        history={history}
        messsageId={+message.dataset.id!}
        nickname={nickname}
        from_id={from_id}
    ></MessageHistory>;

    hideAllActions(message);
    addElementToMessageWrapper(element);
}


